var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',[_c('li',[_c('a',[_vm._v("Yes")])]),_c('li',[_c('a',[_vm._v("No")])])])])}]

export { render, staticRenderFns }